const SingleSelectCheckboxGroup = ({
    fieldId,
    name,
    optionsMap,
    selectedValue,
    onSelect
}) => {
    return (
        <div className="space-y-1">
            {Object.entries(optionsMap).map(([label, encompassValue]) => (
                <label key={encompassValue} className="checkbox-label">
                    <input
                        type="checkbox"
                        className="checkbox-accent"
                        name={name}
                        id={`field-${fieldId}`}
                        value={encompassValue}
                        checked={selectedValue === encompassValue}
                        onChange={(e) => {
                            const newValue = selectedValue === encompassValue ? "" : encompassValue;
                            onSelect(newValue);
                            const group = document.querySelectorAll(`input[name="${name}"]`);
                            group.forEach(cb => {
                                cb.checked = (cb.value === newValue);
                            });
                        }}
                    />
                    {label}
                </label>
            ))}
        </div>
    );
};

export default SingleSelectCheckboxGroup;
